import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { Divider, Typography } from '@mui/material';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: ReactNode;
}

const FilterDrawer: React.FC<Props> = ({ open, setOpen, children }) => {
  return (
    <Drawer open={open} onClose={() => setOpen(false)}>
      <Box
        sx={{
          width: 300,
          padding: 2,
        }}
        role="presentation"
      >
        <Typography variant='h6'>Search by filters</Typography>
        <Divider sx={{ mt: 2 }}></Divider>
        {children}
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
